import React from 'react';
import { SITE_URL } from '../../../config/index.js';

const ShareModal = ({ modalInfo }) => {
  const generateShareLink = (fuseSlug) => {
    return `${SITE_URL}/fuse/${fuseSlug}/`;
  };

  const copyToClipboard = (link) => {
    navigator.clipboard.writeText(link).then(
      () => {
        alert('Link copied to clipboard!');
      },
      (err) => {
        console.error('Could not copy text: ', err);
      }
    );
  };

  return (
    <div className="fuselight-share-modal-content">
      <h3>Share</h3>
      {modalInfo.slug && !modalInfo.pitch_link && (
        <>
          <p>
            Copy the link below to share this fuse:{' '}
            <strong>
              {modalInfo.brand_name} + {modalInfo.celebrity_name}
            </strong>
          </p>
          <button
            className="btn btn--primary-outline"
            onClick={() => copyToClipboard(generateShareLink(modalInfo.slug))}
          >
            Share this Fusion
          </button>
        </>
      )}
      {modalInfo.pitch_link && (
        <>
          <p>
            Copy the link below to share this deck:{' '}
            <strong>{modalInfo.brand_name}</strong>
          </p>
          <button
            className="btn btn--primary-outline"
            onClick={() => copyToClipboard(modalInfo.pitch_link)}
          >
            Share this Deck
          </button>
        </>
      )}
      {!modalInfo.slug && !modalInfo.pitch_link && <p>No link available</p>}
    </div>
  );
};

export default ShareModal;
